// extracted by mini-css-extract-plugin
export default {"avatar":"manage-person-panels_avatar__PJnMU","header":"manage-person-panels_header__eDs+v"};